import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

export class FormaPagamentoFilter implements Filter {
    filterPsq: string;
    situacao: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
    }
}
